// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__VPdSS","logo_seguridad":"Header_logo_seguridad__Qge6n"};